module.exports = __webpack_public_path__ + "media/shared/record@3x-e2d7f42f.png";